import find from 'lodash/find';
import { EventBus } from '../../event-bus.js'

export default {
    default: (app) => {
        console.log('store:default');
    },
    index: (app) => {
        console.log('store:index');
    },
    product: (app) => {
        const $addToCartForm = document.querySelector('.js-add-to-cart');
        const $purchasableIdInput = $addToCartForm.querySelector('.js-add-to-cart__purchasable-input');

        const $productImageButtons = document.querySelectorAll('.js-product__image-button');

        function showModal(contents) {
            EventBus.$emit('open-global-modal', contents);
        } 

        $productImageButtons.forEach(button => {
            button.addEventListener('click', e => {
                let modalContents = {
                    title: '',
                    image: button.dataset.imageUrl
                }
                showModal(modalContents) 
            } );
        })

        if ($purchasableIdInput) {
            // Pull JSON-encoded data off the inputs
            const variantCriteria = JSON.parse($purchasableIdInput.dataset.variantCriteria);
            const variantData = JSON.parse($purchasableIdInput.dataset.variantData);

            console.log(variantData);

            // Get customizable <select> elements:
            const $attributeMenus = $addToCartForm.querySelectorAll('.js-add-to-cart__attribute-menu');

            const $submitButton = $addToCartForm.querySelector('.js-add-to-cart__submit');

            // Our handler function collections criteria from the form
            // and matches it up with one of the variants stashed on
            // the hidden `purchasableId` input, and if one is found,
            // sets the value of the input. Otherwise, we lock the form.
            const handleFormChange = () => {
                const criteria = {};

                $attributeMenus.forEach(($menu) => {
                    criteria[$menu.name] = $menu.value;
                });

                // Lodash.find does a clever object comparison and returns
                // the first matching object in the list. Our variant objects
                // have all their configurable attributes underneath the
                // `fields` key, so that's where we want to search with our
                // criteria object.
                const variant = find(variantData, { fields: criteria });

                // Prevent adding to cart by disabling the submit button when
                // the options don't match a variant, or it's out of stock:
                if (!variant || !variant.inStock) {
                    $submitButton.disabled = true;

                    return;
                }

                // We know there's a variant, so set its ID in the form,
                // and unlock the submit button.
                $purchasableIdInput.value = variant.variantId;
                $submitButton.disabled = false;
            };

            // Hook up our responder...
            $addToCartForm.addEventListener('change', handleFormChange);

            // ...and fire it once to initialize:
            handleFormChange();
        }
    }
}
